<template>
  <div class='featured-projects'>
    <header>
      <CmChiclet v-for="tag in skill_tags" :key="tag.value" v-bind="{
          type: 'radio',
          group: 'projects_skill_tags',
          value: tag.value,
          label: tag.label,
          checked: tag.value === skill_tags,
        }"
      />
    </header>
    <CmMasonryLayout
      class='projects-list'
    >
      <ProjectCard
        v-for="result in results"
        :key="result.id"
        :project="result"
      />
    </CmMasonryLayout>
  </div>
</template>

<script>

import ProjectCard from "../components/project-card";
import CmMasonryLayout from "../components/cm-masonry-layout";
import CmChiclet from "../components/cm-chiclet";

import elasticSearch from "../lib/elastic-search";

export default {
  components: {
    ProjectCard,
    CmMasonryLayout,
    CmChiclet,
  },

  props: {
    isLoggedIn: {
      type: Boolean
    },
    favorites: {
      type: Array
    }
  },

  data() {
    return {
      index: "projects",

      skill_tags: [],

      dynamicFavorites: this.favorites,
      response: null,
    };
  },

  created() {
    const promise = this.fetchResults();
    promise.then(response => {
      this.isLoading = false;
      this.response = response;
    });
  },


  computed: {
    results() {
      if (this.response) {
        return this.response.hits.hits.map(el => {
          return {
            ...el._source
          };
        });
      } else return [];
    },
  },

  methods: {
    fetchResults() {
      this.isLoading = true;

      const promise = elasticSearch({
        index: 'projects',
        size: 6,
        body: {
          sort: [
            { featured_at: "desc" },
          ],
          query: {
            bool: {
              must: [
                { match: { featured: true } },
              ]
            }
          }
        }
      });

      return promise;
    },
  }
};
</script>

<style lang="scss" scoped>
.projects-list.cm-masonry-layout {
  margin: 2.5rem -1rem 2.5rem;
  grid-gap: 0;
  grid-auto-rows: 2px;
  grid-template-columns: repeat(2, 1fr);
  @include min-width (760px) {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>



// WEBPACK FOOTER //
// app/javascript/components/featured-projects.vue?e00c73e8